import nextTick from '../lib/next-tick';

const sectionSelector = '.careers-page-benefits-section';
const sectionCallBack = (sectionElement, query, queryAll) => {
    const columnsRow = query('.benefits-row');
    const columnsParent = queryAll('.benefits-row .col');
    const columns = queryAll('.benefits-col');
    const columnsContent = queryAll('.benefits-col-content');
    const setColumnHeight = () => {
        const height = columnsContent.map((item) => item.getBoundingClientRect().height);
        columns.forEach((item) => {
            item.style.height = `${Math.max(...height)}px`;
        });
    };
    setColumnHeight();
    window.addEventListener('resize', setColumnHeight);
    window.addEventListener('DOMContentLoaded', setColumnHeight);
    window.addEventListener('resize', () => {
        nextTick(setColumnHeight);
    });

    const toggleAccordion = (target, parent) => {
        columnsRow.classList.add('active');
        columnsParent.forEach((item) => {
            item.classList.remove('active');
        });
        columns.forEach((item) => {
            item.classList.remove('active');
        });
        parent.classList.toggle('active');
        target.classList.toggle('active');
    };

    const clearAccordion = (target, parent) => {
        columnsRow.classList.remove('active');
        parent.classList.remove('active');
        target.classList.remove('active');
    };

    columns.forEach((item) => {
        const parent = item.closest('.col');
        item.addEventListener('click', () => {
            // eslint-disable-next-line no-unused-expressions
            parent.classList.contains('active') ? clearAccordion(item, parent) : toggleAccordion(item, parent);
        });
    });
};

export { sectionSelector, sectionCallBack };
